
import { Divider, Grid } from '@mui/material';
import React, { useState } from 'react';
import authService from '../../services/authService';
import InstituteForm from '../manage-institute/instituteForm';
import Programs from '../manage-program/programs';
import GcComposition from './gcComposition';
import CustomTabs from '../common/customTabs';
import TeachingDepartments from '../manage-department/new/teachingDepartments';
import NonTeachingDepartments from '../manage-department/new/nonTeachingDepartments';
import CollegeInfo from '../manage-institute/collegeInfo.page';


const SynizaInstitute = () => {
    const [option, setOption] = useState(null)
    const [selected, setSelected] = useState("composition")
    // let option;
    function onClick(name) {
        //console.log("name trust info:",name);
        setSelected(name);
        setOption(getItem(name));
    }

    function getItem(name) {
        switch (name) {
            case "basicinfo":
                // return <InstituteForm id={authService.getInstituteTenant()} />
                return <CollegeInfo id={authService.getInstituteTenant()} />

            case "composition":
                return <GcComposition />
            case "program":
                return <Programs />
            case "teachingDept":
                return <TeachingDepartments type={"TEACHING"} heading="List of eaching Departmments" />
                case "nonTeachingDept":
                    return <NonTeachingDepartments type={"NON_TEACHING"} heading="List of Non-Teaching Departments" />
            default:
                break;
        }
    }

    function getTabs() {
        return [
            {
                name: "composition", label: "Governing Council"
            },
            {
                name: "basicinfo", label: "College Info"
            },
            {
                name: "program", label: "Program Info"
            },
            {
                name: "teachingDept", label: "Teaching Dept Info"
            },
            {
                name: "nonTeachingDept", label: "Non-Teaching Dept Info"
            },
            {
                name: "gcmeeting", label: "GC Meeting"
            }
        ]
    }


    return (
        <>
            <Grid container columnSpacing={5}>
                {/* {getTabs().map(tab => <Grid item sm={4}>
                    {tab.name === selected ? <Button color='default' fullWidth variant='contained' onClick={() => onClick(tab.name)}> {tab.label} </Button> : <Button color='outlinedDefault' fullWidth variant='outlined' onClick={() => onClick(tab.name)}> {tab.label} </Button>}
                </Grid>)} */}

                <CustomTabs tabs={getTabs()} selected={selected} onClick={onClick} cols={2} />
            </Grid>
            <br />
            <Divider />
            <br />
            <Grid container item sm={12}>
                {getItem(selected)}
            </Grid>
        </>
    );
}

export default SynizaInstitute;